import { render } from "./alertpage.vue?vue&type=template&id=e24d9340&scoped=true"
import script from "./alertpage.vue?vue&type=script&lang=js"
export * from "./alertpage.vue?vue&type=script&lang=js"

import "./alertpage.vue?vue&type=style&index=0&id=e24d9340&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24d9340"]])

export default __exports__